import type { LawFirmCaseRelevantPeople } from '~/models'
import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'

export const GetByLawFirmCaseEncryptionId = params => $apiGet<LawFirmCaseRelevantPeople[]>(`/v1/lawFirmCaseRelevantPeople/byLawFirmCaseEncryptionId`, params)

export const GetByNameAndType = (params, isLoading?) => $apiGet<LawFirmCaseRelevantPeople[]>(`/v1/lawFirmCaseRelevantPeople/byNameAndType`, params, isLoading)

export const GetByNameKeyword = (params, isLoading?) => $apiGet<LawFirmCaseRelevantPeople[]>(`/v1/lawFirmCaseRelevantPeople/byNameKeyword`, params, isLoading)
